import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

      await axios.post(
        `${BACKEND_URL}/api/auth/forgot-password`,
        { email }
      );

      toast.success("Password reset link sent!");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 px-6">
      <div className="w-full max-w-md bg-slate-900/40 backdrop-blur p-8 rounded-2xl">
        <h1 className="text-2xl font-bold text-white mb-2">
          Forgot Password
        </h1>

        <p className="text-slate-400 mb-6">
          Enter your email to receive a reset link
        </p>

        <form onSubmit={handleForgotPassword} className="space-y-4">
          <div>
            <Label className="text-slate-300">
              Email
            </Label>

            <Input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 bg-slate-950/60 border-slate-800 text-white"
              required
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-sky-500 hover:bg-sky-400 text-black"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
        </form>
      </div>
    </div>
  );
}